import img1_1 from "./Assets/products/Bata Jeri/1.jpg";
import img1_2 from "./Assets/products/Bata Jeri/2.jpg";
import img1_3 from "./Assets/products/Bata Jeri/3.jpg";

import img2_1 from "./Assets/products/Corset Shine Off White/1.jpg";
import img2_2 from "./Assets/products/Corset Shine Off White/2.jpg";
import img2_3 from "./Assets/products/Corset Shine Off White/3.jpg";
import img2_4 from "./Assets/products/Corset Shine Off White/4.jpg";

import img3_1 from "./Assets/products/Cropped Jeri Azul Bebê/1.jpg";
import img3_2 from "./Assets/products/Cropped Jeri Azul Bebê/2.jpg";
import img3_3 from "./Assets/products/Cropped Jeri Azul Bebê/3.jpg";
import img3_4 from "./Assets/products/Cropped Jeri Azul Bebê/4.jpg";

import img4_1 from "./Assets/products/Jogo de Banheiro em Crochê - Vermelho Paixão/1.jpg";

import img5_1 from "./Assets/products/Corset Shine Off White/1.jpg";
import img5_2 from "./Assets/products/Corset Shine Off White/2.jpg";
import img5_3 from "./Assets/products/Corset Shine Off White/3.jpg";
import img5_4 from "./Assets/products/Corset Shine Off White/4.jpg";

import img6_1 from "./Assets/products/Top Alika Preto – Linha de Seda/1.jpg";
import img6_2 from "./Assets/products/Top Alika Preto – Linha de Seda/2.jpg";
import img6_3 from "./Assets/products/Top Alika Preto – Linha de Seda/3.jpg";

import img7 from "./Assets/products/bolsas/bolsa1.jpg";
import img8 from "./Assets/products/bolsas/bolsa2.jpg";
import img9 from "./Assets/products/bolsas/bolsa3.jpg";
import img10 from "./Assets/products/bolsas/bolsa4.jpg";
import img11 from "./Assets/products/bolsas/bolsa5.jpg";
import img12 from "./Assets/products/bolsas/bolsa6.jpg";
import img13 from "./Assets/products/bolsas/bolsa7.jpg";
import img14 from "./Assets/products/bolsas/bolsa9.jpg";
import img15 from "./Assets/products/bolsas/bolsa12.jpg";
import img16 from "./Assets/products/bolsas/bolsa11.jpg";
import img17 from "./Assets/products/bolsas/bolsa8.jpg";

const all_product = [
  {
    id: 1,
    name: "Crochê - Bata Jeri",
    category: "cropped",
    images: [img1_1, img1_2, img1_3],
    new_price: 54.99,
    old_price: 74.49,
    
  },
  {
    id: 4,
    name: "Crochê - Corset Shine Off White",
    category: "cropped",
    images: [img2_1, img2_2, img2_3, img2_4],
    new_price: 29.99,
    old_price: 44.79,
  },
  {
    id: 2,
    name: "Crochê - Cropped Jeri Azul Bebê",
    category: "cropped",
    images: [img3_1, img3_2, img3_3, img3_4],
    new_price: 34.49,
    old_price: 64.99,
  },

  {
    id: 5,
    name: "Crochê - Cropped Jeri Off White",
    category: "cropped",
    images: [img5_1, img5_2, img5_3, img5_4],
    new_price: 34.49,
    old_price: 44.99,
  },
  {
    id: 3,
    name: "Crochê - Top Alika Preto – Linha de Seda",
    category: "cropped",
    images: [img6_1, img6_2, img6_3],
    new_price: 27.99,
    old_price: 34.49,
  },
  {
    id: 7,
    name: "Bolsa Sardegna Preta - Tamanho P",
    category: "bolsa",
    images: [img7],
    new_price: 34.98,
    old_price: 49.98,
  },
  {
    id: 8,
    name: "Bolsa Sardegna Laranja - Tamanho P",
    category: "bolsa",
    images: [img8],
    new_price: 35.98,
    old_price: 49.98,
  },
  {
    id: 9,
    name: "Bolsa Sardegna Off White - Tamanho P",
    category: "bolsa",
    images: [img9],
    new_price: 35.98,
    old_price: 49.98,
  },
  {
    id: 10,
    name: "Bolsa Sardegna Terracota - Tamanho P",
    category: "bolsa",
    images: [img10],
    new_price: 35.98,
    old_price: 49.98,
  },
  {
    id: 11,
    name: "Bolsa Sardegna Verde Água - Tamanho P",
    category: "bolsa",
    images: [img11],
    new_price: 35.98,
    old_price: 49.98,
  },
  {
    id: 12,
    name: "Bolsa Sardegna Verde Bandeira - Tamanho P",
    category: "bolsa",
    images: [img12],
    new_price: 39.98,
    old_price: 59.98,
  },
  {
    id: 13,
    name: "Bolsa Sardegna Verde Água - Tamanho G",
    category: "bolsa",
    images: [img13],
    new_price: 39.98,
    old_price: 59.98,
  },
  {
    id: 14,
    name: "Bolsa Sardegna Vermelha - Tamanho G",
    category: "bolsa",
    images: [img14],
    new_price: 39.98,
    old_price: 59.98,
  },
  {
    id: 15,
    name: "Bolsa Sardegna Verde Bandeira - Tamanho G",
    category: "bolsa",
    images: [img15],
    new_price: 39.98,
    old_price: 59.98,
  },
  {
    id: 16,
    name: "Bolsa Sardegna Terracota - Tamanho G",
    category: "bolsa",
    images: [img8],
    new_price: 39.98,
    old_price: 59.98,
  }
]
 
export default all_product